import { render, staticRenderFns } from "./CustomerTabsAttachments.vue?vue&type=template&id=075471b2&scoped=true&"
import script from "./CustomerTabsAttachments.vue?vue&type=script&lang=js&"
export * from "./CustomerTabsAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabsAttachments.vue?vue&type=style&index=0&id=075471b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075471b2",
  null
  
)

export default component.exports